import { render, staticRenderFns } from "./AccrualsAggregations.vue?vue&type=template&id=33a4f484&"
import script from "./AccrualsAggregations.vue?vue&type=script&lang=js&"
export * from "./AccrualsAggregations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports